import * as React from 'react'
import { AttributesTable } from 'shared'
import { FC } from 'react'
import { FieldProps, useRecordContext } from 'react-admin'

export const DataSummaryField: FC<FieldProps & { copyable?: boolean; displayedKeys?: string[]; limit?: number }> = ({
  displayedKeys,
  limit = 3,
  source,
  ...rest
}) => {
  const record = useRecordContext()
  if (!record) return <div>No data</div>

  displayedKeys = displayedKeys.filter(dK => !!record[source][dK]) // only display attrs with values

  return <AttributesTable {...rest} data={record[source]} displayedKeys={displayedKeys} limit={limit} tClass="formtopia-entry-attrs" flatten={false} />
}
